<template>
  <div class="home" ref="container">
    <!-- SCROLL DOWN - 좌측 중앙 고정 -->
    <div class="scroll-indicator" :class="{ 'is-light': isDarkSection }">
      <span>SCROLL DOWN</span>
      <div class="scroll-line"></div>
    </div>

    <div class="sections-wrapper" :class="{ 'mobile-scroll': isMobile }" :style="isMobile ? {} : { transform: `translateY(-${currentSection * 100}vh)` }">
      <HeroSection :is-active="isMobile || (currentSection === 0 && splashDone)" />
      <SummarySection :is-active="isMobile || currentSection === 1" />
      <PremiumSection ref="premium" :is-active="isMobile || currentSection === 2" />
      <UnitSection :is-active="isMobile || currentSection === 3" />
      <CommunitySection ref="community" :is-active="isMobile || currentSection === 4" />
      <ChangeSection :is-active="isMobile || currentSection === 5" />
      <LocationSection :is-active="isMobile || currentSection === 6" />
      <FooterSection :is-active="isMobile || currentSection === 7" />
    </div>
  </div>
</template>

<script>
import HeroSection from '@/components/web/home/HeroSection.vue'
import SummarySection from '@/components/web/home/SummarySection.vue'
import PremiumSection from '@/components/web/home/PremiumSection.vue'
import ChangeSection from '@/components/web/home/ChangeSection.vue'
import CommunitySection from '@/components/web/home/CommunitySection.vue'
import LocationSection from '@/components/web/home/LocationSection.vue'
import UnitSection from '@/components/web/home/UnitSection.vue'
import FooterSection from '@/components/web/home/FooterSection.vue'
export default {
  name: 'HomeView',
  components: {
    HeroSection,
    SummarySection,
    PremiumSection,
    ChangeSection,
    CommunitySection,
    LocationSection,
    UnitSection,
    FooterSection
  },
  data() {
    return {
      currentSection: 0,
      totalSections: 8,
      isScrolling: false,
      splashDone: false,
      isMobile: false
    }
  },
  computed: {
    isDarkSection() {
      if (this.isMobile) return false
      return [0, 1, 2, 3, 4, 5, 7].includes(this.currentSection)
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)

    const appInstance = this.$root
    if (appInstance && !appInstance.showSplash) {
      this.splashDone = true
    }
    window.addEventListener('splash-done', this.onSplashDone)

    // 데스크톱에서만 풀페이지 스크롤 리스너
    if (!this.isMobile) {
      window.addEventListener('wheel', this.handleWheel, { passive: false })
      window.addEventListener('keydown', this.handleKeydown)
      window.addEventListener('touchstart', this.handleTouchStart, { passive: true })
      window.addEventListener('touchend', this.handleTouchEnd, { passive: true })
    } else {
      // 모바일: 모든 섹션 활성화 상태로 표시
      this.currentSection = -1 // 모든 섹션이 애니메이션 없이 활성화
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
    window.removeEventListener('wheel', this.handleWheel)
    window.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('splash-done', this.onSplashDone)
    window.removeEventListener('touchstart', this.handleTouchStart)
    window.removeEventListener('touchend', this.handleTouchEnd)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    onSplashDone() {
      this.splashDone = true
    },
    handleWheel(e) {
      if (e.target.closest('.thumb-slider')) return

      e.preventDefault()
      if (this.isScrolling) return

      // 프리미엄 내부 스크롤
      const premium = this.$refs.premium
      if (this.currentSection === 2 && premium) {
        if (e.deltaY > 0 && premium.canScrollDown()) {
          this.isScrolling = true
          premium.scrollDown()
          setTimeout(() => { this.isScrolling = false }, 1600)
          return
        }
        if (e.deltaY < 0 && premium.canScrollUp()) {
          this.isScrolling = true
          premium.scrollUp()
          setTimeout(() => { this.isScrolling = false }, 1600)
          return
        }
      }

      // 커뮤니티 내부 스크롤
      const community = this.$refs.community
      if (this.currentSection === 4 && community) {
        if (e.deltaY > 0 && community.canScrollDown()) {
          this.isScrolling = true
          community.scrollDown()
          setTimeout(() => { this.isScrolling = false }, 1600)
          return
        }
        if (e.deltaY < 0 && community.canScrollUp()) {
          this.isScrolling = true
          community.scrollUp()
          setTimeout(() => { this.isScrolling = false }, 1600)
          return
        }
      }

      if (e.deltaY > 0) {
        this.goToSection(this.currentSection + 1)
      } else if (e.deltaY < 0) {
        if (this.currentSection - 1 === 2 && this.$refs.premium) {
          this.$refs.premium.resetStep()
        }
        if (this.currentSection - 1 === 4 && this.$refs.community) {
          this.$refs.community.resetStep()
        }
        this.goToSection(this.currentSection - 1)
      }
    },
    handleKeydown(e) {
      if (this.isScrolling) return

      if (e.key === 'ArrowDown' || e.key === 'PageDown') {
        e.preventDefault()
        this.goToSection(this.currentSection + 1)
      } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
        e.preventDefault()
        this.goToSection(this.currentSection - 1)
      }
    },
    handleTouchStart(e) {
      this.touchStartY = e.touches[0].clientY
    },
    isInsideScrollable(e) {
      // 내부 스크롤 가능한 섹션(Location, Footer) 안에서 스크롤 중이면 섹션 이동 막기
      const el = e.target.closest('.location-section, .footer-section')
      if (!el) return false
      const { scrollTop, scrollHeight, clientHeight } = el
      const diff = this.touchStartY - e.changedTouches[0].clientY
      if (diff > 0) {
        // 아래로 스와이프 - 아직 맨 아래 아니면 내부 스크롤
        return scrollTop + clientHeight < scrollHeight - 5
      } else {
        // 위로 스와이프 - 아직 맨 위 아니면 내부 스크롤
        return scrollTop > 5
      }
    },
    handleTouchEnd(e) {
      if (this.isScrolling) return
      const touchEndY = e.changedTouches[0].clientY
      const diff = this.touchStartY - touchEndY

      if (Math.abs(diff) < 50) return

      // 내부 스크롤 가능한 영역이면 섹션 이동 안 함
      if (this.isInsideScrollable(e)) return

      if (diff > 0) {
        // 프리미엄 내부 스크롤
        const premium = this.$refs.premium
        if (this.currentSection === 2 && premium && premium.canScrollDown()) {
          this.isScrolling = true
          premium.scrollDown()
          setTimeout(() => { this.isScrolling = false }, 1600)
          return
        }
        // 커뮤니티 내부 스크롤
        const community = this.$refs.community
        if (this.currentSection === 4 && community && community.canScrollDown()) {
          this.isScrolling = true
          community.scrollDown()
          setTimeout(() => { this.isScrolling = false }, 1600)
          return
        }
        this.goToSection(this.currentSection + 1)
      } else {
        const premium = this.$refs.premium
        if (this.currentSection === 2 && premium && premium.canScrollUp()) {
          this.isScrolling = true
          premium.scrollUp()
          setTimeout(() => { this.isScrolling = false }, 1600)
          return
        }
        const community = this.$refs.community
        if (this.currentSection === 4 && community && community.canScrollUp()) {
          this.isScrolling = true
          community.scrollUp()
          setTimeout(() => { this.isScrolling = false }, 1600)
          return
        }
        if (this.currentSection - 1 === 2 && this.$refs.premium) {
          this.$refs.premium.resetStep()
        }
        if (this.currentSection - 1 === 4 && this.$refs.community) {
          this.$refs.community.resetStep()
        }
        this.goToSection(this.currentSection - 1)
      }
    },
    goToSection(index) {
      if (index < 0 || index >= this.totalSections) return
      if (this.isScrolling) return

      this.isScrolling = true
      this.currentSection = index

      setTimeout(() => {
        this.isScrolling = false
      }, 1600)
    }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.sections-wrapper {
  transition: transform 1.4s cubic-bezier(0.65, 0, 0.35, 1);
  will-change: transform;
}

/* ===== SCROLL DOWN ===== */
.scroll-indicator {
  position: fixed;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.scroll-indicator span {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-family: var(--font-pretendard);
  font-size: 10px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 4px;
  text-transform: uppercase;
  transition: color 0.5s ease;
}

.scroll-line {
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
}

.scroll-line::after {
  content: '';
  position: absolute;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  animation: scrollAnim 2s ease-in-out infinite;
}

@keyframes scrollAnim {
  0% { top: -100%; }
  50% { top: 100%; }
  100% { top: 100%; }
}

/* 모바일 반응형 */
@media (max-width: 768px) {
  /* 모바일: 풀페이지 스크롤 해제 → 일반 세로 스크롤 */
  .home {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .sections-wrapper.mobile-scroll {
    transform: none !important;
    transition: none !important;
  }

  /* 스크롤 인디케이터 모바일 숨김 */
  .scroll-indicator {
    display: none;
  }
}
</style>
